import Hashids from "hashids";


const appName = process.env.REACT_APP_APP_NAME || null;
const hashids = new Hashids(`${appName}-secret-salt`, 10, "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"); 

export const encodeId = (id) => hashids.encode(id);
export const decodeId = (hash) => hashids.decode(hash)[0];